<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'user.nav-all'"></app-header-bar>
  </div>
  <div class="content mt-2 mb-3">
    <div class="row">
      <app-datatable
        [dataSource]="userSource"
        [columns]="columns"
        [identifier]="'all-users'"
        [customActions]="customActions"
        [iconActions]="iconActions"
        (newEvent)="new()"
        (showEvent)="edit($event.valueOf())"
      >
        <app-empty-table [icon]="'person'" [emptyText]="'user.empty_text' | translate"> </app-empty-table>
      </app-datatable>

      <app-error [error]="error"></app-error>

      <app-model-modal #EditModal (saveEvent)="onSave()">
        <app-user-form #form (closeEvent)="onEditModalClose()" [allUserTable]="true" (loadingEvent)="onLoading($event.valueOf())"></app-user-form>
      </app-model-modal>

      <app-model-modal #ChangeUserPrimaryOrganizationModal (saveEvent)="onChangePrimaryOrgSave()">
        <app-user-change-primary-org (closeEvent)="onChangePrimaryOrgModalClose()" (loadingEvent)="onChangePrimaryOrgLoading($event.valueOf())"></app-user-change-primary-org>
      </app-model-modal>
    </div>
  </div>
</div>
